import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useMapTypeControl } from './useMapTypeControl';
export * from './useMapTypeControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    mapTypeControl
  } = useMapTypeControl(props);
  useImperativeHandle(ref, () => _extends({}, props, {
    mapTypeControl
  }), [mapTypeControl, props]);
  return null;
});